/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bzHsBkgGqqFqgQ8Ug5BFVy
// Component: veiKv14MX-Ss
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: veiKv14MX-Ss/css
import Icon8Icon from "./icons/PlasmicIcon__Icon8"; // plasmic-import: 4PXEnoMcmxWn/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: M6UJ_nikhUMm/icon
import Icon3Icon from "./icons/PlasmicIcon__Icon3"; // plasmic-import: nGQyuSCWzfEK/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "haaaven",
    description: "A haven for the individual in this erosive modern world.",
    openGraph: {
      title: "haaaven",
      description: "A haven for the individual in this erosive modern world.",
      images: [
        "https://site-assets.plasmic.app/a02373cfa1a3a523dedd0a3028844f53.svg"
      ]
    },
    twitter: {
      card: "summary_large_image",
      title: "haaaven",
      description: "A haven for the individual in this erosive modern world.",
      images: [
        "https://site-assets.plasmic.app/a02373cfa1a3a523dedd0a3028844f53.svg"
      ]
    }
  };
}

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array();

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_bzHsBkgGqqFqgQ8Ug5BFVy",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root,
          "auto-scroll"
        )}
      >
        <section
          data-plasmic-name={"section"}
          data-plasmic-override={overrides.section}
          className={classNames("all", sty.section)}
        >
          <div
            data-plasmic-name={"container"}
            data-plasmic-override={overrides.container}
            className={classNames("all", sty.container)}
          >
            <div
              data-plasmic-name={"nav"}
              data-plasmic-override={overrides.nav}
              className={classNames("all", sty.nav)}
            >
              <div
                data-plasmic-name={"columnsForNav"}
                data-plasmic-override={overrides.columnsForNav}
                className={classNames("all", sty.columnsForNav)}
              >
                <div
                  data-plasmic-name={"column1Wrapper2"}
                  data-plasmic-override={overrides.column1Wrapper2}
                  className={classNames("all", sty.column1Wrapper2)}
                >
                  <div className={classNames("all", sty.freeBox___0AsK)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text___6S7Ic
                      )}
                    >
                      {"a."}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"column2Wrapper2"}
                  data-plasmic-override={overrides.column2Wrapper2}
                  className={classNames("all", sty.column2Wrapper2)}
                >
                  <div className={classNames("all", sty.freeBox__jjVhG)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__uxIte
                      )}
                    >
                      {"PROJECTS"}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"column2Wrapper3"}
                  data-plasmic-override={overrides.column2Wrapper3}
                  className={classNames("all", sty.column2Wrapper3)}
                >
                  <div className={classNames("all", sty.freeBox__a4Euq)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__pNdOw
                      )}
                    >
                      {"PEOPLE"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"columns"}
              data-plasmic-override={overrides.columns}
              className={classNames("all", sty.columns)}
            >
              <div
                data-plasmic-name={"column1Wrapper"}
                data-plasmic-override={overrides.column1Wrapper}
                className={classNames("all", sty.column1Wrapper)}
              >
                <div
                  data-plasmic-name={"heroSection"}
                  data-plasmic-override={overrides.heroSection}
                  className={classNames("all", sty.heroSection)}
                >
                  <div
                    data-plasmic-name={"logoMarkWrapper"}
                    data-plasmic-override={overrides.logoMarkWrapper}
                    className={classNames("all", sty.logoMarkWrapper)}
                  >
                    <Icon8Icon
                      data-plasmic-name={"logoMarkIocn"}
                      data-plasmic-override={overrides.logoMarkIocn}
                      className={classNames("all", sty.logoMarkIocn)}
                      role={"img"}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__dltsT)}>
                    <IconIcon
                      aria-label={"haaaven"}
                      className={classNames("all", sty.svg__nQz1N)}
                      role={"img"}
                    />
                  </div>
                </div>
                <div
                  data-plasmic-name={"esseySection"}
                  data-plasmic-override={overrides.esseySection}
                  className={classNames("all", sty.esseySection)}
                >
                  <div className={classNames("all", sty.freeBox__gqfr3)}>
                    <h1
                      className={classNames(
                        "all",
                        "h1",
                        "h1__bzHsB",
                        "__wab_text",
                        sty.h1__ltzuL
                      )}
                    >
                      {
                        "a haven for the individual in this erosive modern world."
                      }
                    </h1>
                    <div
                      data-plasmic-name={"copyContainer"}
                      data-plasmic-override={overrides.copyContainer}
                      className={classNames("all", sty.copyContainer)}
                    >
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__j7CxB
                        )}
                      >
                        {
                          "Why do you have to go to school? \nWhy do you need a smartphone?\nWhy stop at a red light when there is absolutely no one around?"
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p___3Fmm4
                        )}
                      >
                        {
                          "As societal systems embed themselves into every aspect of our lives, the relentless pursuit of efficiency threatens to erase the essence of what makes us human. With each small compromise, made for the sake of convenience and the comfort of conformity, we gradually erode our autonomy."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__wrz5I
                        )}
                      >
                        {
                          "Step by step, we trade creativity and individuality for predictable outcomes, quietly surrendering our unique impulses to a system that prioritizes uniformity over genuine human experience."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__ytdAa
                        )}
                      >
                        {
                          "Sooner or later, the pervasive influence of efficiency will overshadow human creative expression. When that moment comes, how will you make sure you have the agency to make choices that align with who you are and who you want to become?"
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__dfzKw
                        )}
                      >
                        {
                          "Surrounded by questions like those, and many more that no one really answered, while there\u2019s a fundamental shift in how the world works, we came to a simple conclusion:"
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p___9Wuzh
                        )}
                      >
                        {
                          "This is the world and reality we\u2019ve just entered."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__l73Li
                        )}
                      >
                        {"The future is inherently uncertain."}
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__x1K4L
                        )}
                      >
                        {"We live in a technological society."}
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__qEmhu
                        )}
                      >
                        {
                          "A society governed by systems that built the modern world and now shape how people think, work, and communicate; what they pay attention to, what they ignore, and what they no longer even think to question."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p___9YxX2
                        )}
                      >
                        {
                          "A system that treats the individual as an interchangeable economic unit, an operator in a bigger mechanism."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p___2X5Vj
                        )}
                      >
                        {
                          "To us, accepting that as the foundation for the future we want to create is an ignorant mistake."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p___2SyM9
                        )}
                      >
                        {
                          "Because November 2022 marks the moment when redesigning that system, by rewriting its function, became a real possibility."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__ayxPz
                        )}
                      >
                        {"And this is how we do it:"}
                      </p>
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__teFwm)}>
                    <h2
                      className={classNames(
                        "all",
                        "h2",
                        "h2__bzHsB",
                        "__wab_text",
                        sty.h2__hKPuz
                      )}
                    >
                      {"o21p"}
                    </h2>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p__i7KKx
                      )}
                    >
                      {
                        "Human-scale digital infrastructure for independent founders, professionals, and freelancers navigating the 21st-century digital world without sacrificing autonomy."
                      }
                    </p>
                  </div>
                  <div className={classNames("all", sty.freeBox__exR0Y)}>
                    <h2
                      className={classNames(
                        "all",
                        "h2",
                        "h2__bzHsB",
                        "__wab_text",
                        sty.h2__xWf0O
                      )}
                    >
                      {"labs."}
                    </h2>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__bWzEz
                      )}
                    >
                      {"Coming next..."}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"copyContainer2"}
                    data-plasmic-override={overrides.copyContainer2}
                    className={classNames("all", sty.copyContainer2)}
                  >
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p__xdo31
                      )}
                    >
                      {"There\u2019s a lot of work to be done."}
                    </p>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p___34Erz
                      )}
                    >
                      {
                        "These are just the first expressions of the change we want to see in the world. We hope some of it resonates with you and that you see a place for yourself here."
                      }
                    </p>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p__wwpM
                      )}
                    >
                      {
                        "If you don\u2019t see a place yet, this is your invitation to join the haven and create your own."
                      }
                    </p>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p__i86HX
                      )}
                    >
                      {"Either way,"}
                    </p>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p___2IoFg
                      )}
                    >
                      {"Just reach out!"}
                    </p>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p__sHz9F
                      )}
                    >
                      {"cristian@haaaven.com"}
                    </p>
                  </div>
                </div>
                <div className={classNames("all", sty.freeBox___4IRs0)}>
                  <div
                    className={classNames("all", "__wab_text", sty.text__wNaVs)}
                  >
                    {"\u00a9 2026 haaaven - all rights reserved."}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"column2Wrapper"}
                data-plasmic-override={overrides.column2Wrapper}
                className={classNames("all", sty.column2Wrapper)}
              >
                <div
                  data-plasmic-name={"heroSection4"}
                  data-plasmic-override={overrides.heroSection4}
                  className={classNames("all", sty.heroSection4)}
                />

                <div
                  data-plasmic-name={"esseySectionCopy3"}
                  data-plasmic-override={overrides.esseySectionCopy3}
                  className={classNames("all", sty.esseySectionCopy3)}
                />

                <div className={classNames("all", sty.freeBox__cjC4Q)}>
                  <div
                    data-plasmic-name={"projectWrapper15"}
                    data-plasmic-override={overrides.projectWrapper15}
                    className={classNames("all", sty.projectWrapper15)}
                  >
                    <div className={classNames("all", sty.freeBox___0UWp9)}>
                      <div className={classNames("all", sty.freeBox__jL7J7)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__cFTgS
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__bsvvw
                                )}
                                href={"https://o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__yfLkj)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__ecgcz
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__qrhP5
                                )}
                                href={"https://partner.o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"partner.o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__fPfsO)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__xhcPv
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__rNiE7
                                )}
                                href={"https://team.o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"team.o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__tSi9U)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__xmcSf
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__nyCo7
                                )}
                                href={"https://nexus.o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"nexus.o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"projectWrapper18"}
                    data-plasmic-override={overrides.projectWrapper18}
                    className={classNames("all", sty.projectWrapper18)}
                  >
                    <div className={classNames("all", sty.freeBox__xdEc)}>
                      <Icon3Icon
                        className={classNames("all", sty.svg__b7BF)}
                        role={"img"}
                      />
                    </div>
                    <div className={classNames("all", sty.freeBox__hesvV)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__t08Ir
                        )}
                      >
                        {"nexus"}
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__v1V9U
                        )}
                      >
                        {"We're working on this..."}
                      </div>
                    </div>
                    <div className={classNames("all", sty.freeBox__pAai)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__i1ZKr
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__ge508
                              )}
                              href={"https://nexus.o21p.com/"}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"nexus.o21p.com"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"column3Wrapper"}
                data-plasmic-override={overrides.column3Wrapper}
                className={classNames("all", sty.column3Wrapper)}
              >
                <div
                  data-plasmic-name={"heroSection5"}
                  data-plasmic-override={overrides.heroSection5}
                  className={classNames("all", sty.heroSection5)}
                />

                <div
                  data-plasmic-name={"esseySectionCopy2"}
                  data-plasmic-override={overrides.esseySectionCopy2}
                  className={classNames("all", sty.esseySectionCopy2)}
                />

                <div className={classNames("all", sty.freeBox__kahb)}>
                  <div
                    data-plasmic-name={"projectWrapper5"}
                    data-plasmic-override={overrides.projectWrapper5}
                    className={classNames("all", sty.projectWrapper5)}
                  >
                    <div className={classNames("all", sty.freeBox__vu685)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__semI
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link___8NpDq
                              )}
                              href={`/cristian`}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"cristian popa"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__peT2S
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"iulian matei"}
                          </span>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"projectWrapper7"}
                    data-plasmic-override={overrides.projectWrapper7}
                    className={classNames("all", sty.projectWrapper7)}
                  >
                    <div className={classNames("all", sty.freeBox__eQH1)}>
                      <Icon3Icon
                        className={classNames("all", sty.svg__ia4XM)}
                        role={"img"}
                      />
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__qYws5
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {"[ "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__bzHsB",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link___4Do7R
                            )}
                            href={"https://x.com/cristiaaanpopa"}
                            platform={"react"}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                }
                                style={{ color: "#FFFFFF" }}
                              >
                                {"cristian popa"}
                              </span>
                            </React.Fragment>
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {" ]"}
                        </span>
                      </React.Fragment>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {(hasVariant(globalVariants, "screen", "mobile") ? true : false) ? (
          <div
            data-plasmic-name={"columnsMobile"}
            data-plasmic-override={overrides.columnsMobile}
            className={classNames("all", sty.columnsMobile)}
          >
            <div
              data-plasmic-name={"column1Wrapper4"}
              data-plasmic-override={overrides.column1Wrapper4}
              className={classNames("all", sty.column1Wrapper4)}
            >
              <div
                data-plasmic-name={"heroSection3"}
                data-plasmic-override={overrides.heroSection3}
                className={classNames("all", sty.heroSection3)}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__giNcN)}
                >
                  {"a."}
                </div>
                <div className={classNames("all", sty.freeBox__f18Xc)}>
                  <IconIcon
                    className={classNames("all", sty.svg__zMiF7)}
                    role={"img"}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"esseySection3"}
                data-plasmic-override={overrides.esseySection3}
                className={classNames("all", sty.esseySection3)}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__nzPd)}
                >
                  {"a haven for creativity in a technological world."}
                </div>
                <div
                  className={classNames("all", "__wab_text", sty.text__vUgo)}
                >
                  {
                    "Why do you have to go to school?\nWhy do you need a smartphone?\nWhy stop at a red light when there is absolutely no one around?...\n\nAs societal systems embed themselves into every aspect of our lives, the relentless pursuit of efficiency threatens to erase the essence of what makes us human. With each small compromise, made for the sake of convenience and the comfort of conformity, we gradually erode our autonomy. Step by step, we trade creativity and individuality for predictable outcomes, quietly surrendering our unique impulses to a system that prioritizes uniformity over genuine human experience.\n\nSooner or later, the pervasive influence of efficiency will overshadow human creative expression. When that moment comes, how will you make sure you have the agency to make the choices that align with who you are and want to become?\n\n\u2026"
                  }
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__u8Laj)}>
                <div
                  data-plasmic-name={"projectWrapper9"}
                  data-plasmic-override={overrides.projectWrapper9}
                  className={classNames("all", sty.projectWrapper9)}
                >
                  <div className={classNames("all", sty.freeBox__mLkp)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__saRi
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__nny5Y)}
                  >
                    {
                      "We\u2019re rebuilding practice management systems from the ground up, letting independent professionals shape their tools (not the other way around), and putting good design at the heart of healthcare tech."
                    }
                  </div>
                </div>
                <div
                  data-plasmic-name={"projectWrapper10"}
                  data-plasmic-override={overrides.projectWrapper10}
                  className={classNames("all", sty.projectWrapper10)}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__vaZcD)}
                  >
                    {"human user interface."}
                  </div>
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___61MA6
                    )}
                  >
                    {"Infrastructure design research."}
                  </div>
                </div>
              </div>
              <div className={classNames("all", "__wab_text", sty.text__gduA2)}>
                {"\u00a9 2025 HAAAVEN SRL. All rights reserved."}
              </div>
            </div>
          </div>
        ) : null}
        {(
          hasVariant(globalVariants, "screen", "mobile")
            ? true
            : hasVariant(globalVariants, "screen", "tablet")
              ? true
              : false
        ) ? (
          <div
            data-plasmic-name={"columnsMobile2"}
            data-plasmic-override={overrides.columnsMobile2}
            className={classNames("all", sty.columnsMobile2)}
          >
            <div
              data-plasmic-name={"column1Wrapper5"}
              data-plasmic-override={overrides.column1Wrapper5}
              className={classNames("all", sty.column1Wrapper5)}
            >
              <div
                data-plasmic-name={"heroSection6"}
                data-plasmic-override={overrides.heroSection6}
                className={classNames("all", sty.heroSection6)}
              >
                <div
                  data-plasmic-name={"logoMarkWrapp"}
                  data-plasmic-override={overrides.logoMarkWrapp}
                  className={classNames("all", sty.logoMarkWrapp)}
                >
                  <Icon8Icon
                    className={classNames("all", sty.svg__thBoo)}
                    role={"img"}
                  />
                </div>
                <div className={classNames("all", sty.freeBox__tH4Ud)}>
                  <IconIcon
                    className={classNames("all", sty.svg__gqoDx)}
                    role={"img"}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"esseySection4"}
                data-plasmic-override={overrides.esseySection4}
                className={classNames("all", sty.esseySection4)}
              >
                <h1
                  className={classNames(
                    "all",
                    "h1",
                    "h1__bzHsB",
                    "__wab_text",
                    sty.h1__bcWw4
                  )}
                >
                  {"a haven for the individual in this erosive modern world."}
                </h1>
                <div
                  data-plasmic-name={"copyContainer3"}
                  data-plasmic-override={overrides.copyContainer3}
                  className={classNames("all", sty.copyContainer3)}
                >
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__kwFvH
                    )}
                  >
                    {
                      "Why do you have to go to school? \nWhy do you need a smartphone?\nWhy stop at a red light when there is absolutely no one around?"
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__kHkPx
                    )}
                  >
                    {
                      "As societal systems embed themselves into every aspect of our lives, the relentless pursuit of efficiency threatens to erase the essence of what makes us human. With each small compromise, made for the sake of convenience and the comfort of conformity, we gradually erode our autonomy."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__pwuwq
                    )}
                  >
                    {
                      "Step by step, we trade creativity and individuality for predictable outcomes, quietly surrendering our unique impulses to a system that prioritizes uniformity over genuine human experience."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p___7R0M
                    )}
                  >
                    {
                      "Sooner or later, the pervasive influence of efficiency will overshadow human creative expression. When that moment comes, how will you make sure you have the agency to make choices that align with who you are and who you want to become?"
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__esVWd
                    )}
                  >
                    {
                      "Surrounded by questions like those, and many more that no one really answered, while there\u2019s a fundamental shift in how the world works, we came to a simple conclusion:"
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__zQoIu
                    )}
                  >
                    {"This is the world and reality we\u2019ve just entered."}
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__elNJx
                    )}
                  >
                    {"The future is inherently uncertain."}
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p___80Dte
                    )}
                  >
                    {"We live in a technological society."}
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p___5EJx
                    )}
                  >
                    {
                      "A society governed by systems that built the modern world and now shape how people think, work, and communicate; what they pay attention to, what they ignore, and what they no longer even think to question."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__euxk3
                    )}
                  >
                    {
                      "A system that treats the individual as an interchangeable economic unit, an operator in a bigger mechanism."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__dwGfb
                    )}
                  >
                    {
                      "To us, accepting that as the foundation for the future we want to create is an ignorant mistake."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__tthKk
                    )}
                  >
                    {
                      "Because November 2022 marks the moment when redesigning that system, by rewriting its function, became a real possibility."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__apu4Y
                    )}
                  >
                    {"And this is how we do it:"}
                  </p>
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__sOjpO)}>
                <div
                  data-plasmic-name={"projectWrapper11"}
                  data-plasmic-override={overrides.projectWrapper11}
                  className={classNames("all", sty.projectWrapper11)}
                >
                  <div className={classNames("all", sty.freeBox__uc9Rn)}>
                    <Icon3Icon
                      className={classNames("all", sty.svg__bqst)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__tnbfh
                      )}
                    >
                      {"PORTFOLIO PROJECT."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__us1Co)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__cewbV
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox___64Y7Y)}>
                    <h2
                      className={classNames(
                        "all",
                        "h2",
                        "h2__bzHsB",
                        "__wab_text",
                        sty.h2___5K7Cc
                      )}
                    >
                      {"o21p"}
                    </h2>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bzHsB",
                        "__wab_text",
                        sty.p__yfiUz
                      )}
                    >
                      {
                        "Human-scale digital infrastructure for independent founders, professionals, and freelancers navigating the 21st-century digital world without sacrificing autonomy."
                      }
                    </p>
                  </div>
                  <div className={classNames("all", sty.freeBox__cqdMu)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__i1JCg
                      )}
                    >
                      {"// WEBSITES"}
                    </div>
                    <div className={classNames("all", sty.freeBox__vKs5A)}>
                      <div className={classNames("all", sty.freeBox___5SlaZ)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__ttcMk
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__faRrp
                                )}
                                href={"https://o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__noQyU)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__mrggm
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__kDzrd
                                )}
                                href={"https://partner.o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"partner.o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__kxusn)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___3Iwlo
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__p4Yay
                                )}
                                href={"https://team.o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"team.o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox___5Ag2L)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__zHjN
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__riqNx
                                )}
                                href={"https://nexus.o21p.com/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"nexus.o21p.com"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__daWf)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__jkVlL
                      )}
                    >
                      {"// CONTRIBUTORS"}
                    </div>
                    <div className={classNames("all", sty.freeBox__eEaBh)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__lXrY9
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__w05My
                              )}
                              href={`/cristian`}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"cristian popa"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__tCptQ
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"iulian matei"}
                          </span>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"projectWrapper13"}
                  data-plasmic-override={overrides.projectWrapper13}
                  className={classNames("all", sty.projectWrapper13)}
                >
                  <div className={classNames("all", sty.freeBox__gQ9Jh)}>
                    <Icon3Icon
                      className={classNames("all", sty.svg__xFaKf)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__pQeVp
                      )}
                    >
                      {"PORTFOLIO PROJECT."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__ykp2I)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__tHuQm
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__p01Uv)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__jrs5J
                      )}
                    >
                      {"labs."}
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__nxNp
                      )}
                    >
                      {"Coming next..."}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"projectWrapper12"}
                  data-plasmic-override={overrides.projectWrapper12}
                  className={classNames("all", sty.projectWrapper12)}
                >
                  <div className={classNames("all", sty.freeBox__zilmg)}>
                    <Icon3Icon
                      className={classNames("all", sty.svg__wv0X)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__dcsaw
                      )}
                    >
                      {"PORTFOLIO PROJECT."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__vRNb0)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__m1Q70
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__v1OOo)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__kztkn
                      )}
                    >
                      {"nexus"}
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__y6QWu
                      )}
                    >
                      {"Working on it..."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__s7J9K)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__znv4
                      )}
                    >
                      {"WEBSITE."}
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__rBu7S
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {"[ "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__bzHsB",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link__vw6Ol
                            )}
                            href={"https://nexus.o21p.com/"}
                            platform={"react"}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                }
                                style={{ color: "#FFFFFF" }}
                              >
                                {"nexus.o21p.com"}
                              </span>
                            </React.Fragment>
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {" ]"}
                        </span>
                      </React.Fragment>
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__xgMy0)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__fHh9S
                      )}
                    >
                      {"CONTRIBUTORS."}
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__wU3F
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {"[ "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__bzHsB",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link__aUxjn
                            )}
                            href={"https://x.com/cristiaaanpopa"}
                            platform={"react"}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                }
                                style={{ color: "#FFFFFF" }}
                              >
                                {"cristian popa"}
                              </span>
                            </React.Fragment>
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {" ]"}
                        </span>
                      </React.Fragment>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"esseySection5"}
                data-plasmic-override={overrides.esseySection5}
                className={classNames("all", sty.esseySection5)}
              >
                <div
                  data-plasmic-name={"copyContainer4"}
                  data-plasmic-override={overrides.copyContainer4}
                  className={classNames("all", sty.copyContainer4)}
                >
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__tTvOy
                    )}
                  >
                    {"There\u2019s a lot of work to be done."}
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__rr70I
                    )}
                  >
                    {
                      "These are just the first expressions of the change we want to see in the world. We hope some of it resonates with you and that you see a place for yourself here."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p___2EXu0
                    )}
                  >
                    {
                      "If you don\u2019t see a place yet, this is your invitation to join the haven and create your own."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p___2DkpW
                    )}
                  >
                    {"Either way,"}
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__wUwsR
                    )}
                  >
                    {"Just reach out!"}
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bzHsB",
                      "__wab_text",
                      sty.p__qJyZc
                    )}
                  >
                    {"cristian@haaaven.com"}
                  </p>
                </div>
              </div>
              <div className={classNames("all", "__wab_text", sty.text__s94Ze)}>
                {"\u00a9 2026 haaaven - all rights reserved."}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "section",
    "container",
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3",
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "esseySection",
    "copyContainer",
    "copyContainer2",
    "column2Wrapper",
    "heroSection4",
    "esseySectionCopy3",
    "projectWrapper15",
    "projectWrapper18",
    "column3Wrapper",
    "heroSection5",
    "esseySectionCopy2",
    "projectWrapper5",
    "projectWrapper7",
    "columnsMobile",
    "column1Wrapper4",
    "heroSection3",
    "esseySection3",
    "projectWrapper9",
    "projectWrapper10",
    "columnsMobile2",
    "column1Wrapper5",
    "heroSection6",
    "logoMarkWrapp",
    "esseySection4",
    "copyContainer3",
    "projectWrapper11",
    "projectWrapper13",
    "projectWrapper12",
    "esseySection5",
    "copyContainer4"
  ],

  section: [
    "section",
    "container",
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3",
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "esseySection",
    "copyContainer",
    "copyContainer2",
    "column2Wrapper",
    "heroSection4",
    "esseySectionCopy3",
    "projectWrapper15",
    "projectWrapper18",
    "column3Wrapper",
    "heroSection5",
    "esseySectionCopy2",
    "projectWrapper5",
    "projectWrapper7"
  ],

  container: [
    "container",
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3",
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "esseySection",
    "copyContainer",
    "copyContainer2",
    "column2Wrapper",
    "heroSection4",
    "esseySectionCopy3",
    "projectWrapper15",
    "projectWrapper18",
    "column3Wrapper",
    "heroSection5",
    "esseySectionCopy2",
    "projectWrapper5",
    "projectWrapper7"
  ],

  nav: [
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3"
  ],

  columnsForNav: [
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3"
  ],

  column1Wrapper2: ["column1Wrapper2"],
  column2Wrapper2: ["column2Wrapper2"],
  column2Wrapper3: ["column2Wrapper3"],
  columns: [
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "esseySection",
    "copyContainer",
    "copyContainer2",
    "column2Wrapper",
    "heroSection4",
    "esseySectionCopy3",
    "projectWrapper15",
    "projectWrapper18",
    "column3Wrapper",
    "heroSection5",
    "esseySectionCopy2",
    "projectWrapper5",
    "projectWrapper7"
  ],

  column1Wrapper: [
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "esseySection",
    "copyContainer",
    "copyContainer2"
  ],

  heroSection: ["heroSection", "logoMarkWrapper", "logoMarkIocn"],
  logoMarkWrapper: ["logoMarkWrapper", "logoMarkIocn"],
  logoMarkIocn: ["logoMarkIocn"],
  esseySection: ["esseySection", "copyContainer", "copyContainer2"],
  copyContainer: ["copyContainer"],
  copyContainer2: ["copyContainer2"],
  column2Wrapper: [
    "column2Wrapper",
    "heroSection4",
    "esseySectionCopy3",
    "projectWrapper15",
    "projectWrapper18"
  ],

  heroSection4: ["heroSection4"],
  esseySectionCopy3: ["esseySectionCopy3"],
  projectWrapper15: ["projectWrapper15"],
  projectWrapper18: ["projectWrapper18"],
  column3Wrapper: [
    "column3Wrapper",
    "heroSection5",
    "esseySectionCopy2",
    "projectWrapper5",
    "projectWrapper7"
  ],

  heroSection5: ["heroSection5"],
  esseySectionCopy2: ["esseySectionCopy2"],
  projectWrapper5: ["projectWrapper5"],
  projectWrapper7: ["projectWrapper7"],
  columnsMobile: [
    "columnsMobile",
    "column1Wrapper4",
    "heroSection3",
    "esseySection3",
    "projectWrapper9",
    "projectWrapper10"
  ],

  column1Wrapper4: [
    "column1Wrapper4",
    "heroSection3",
    "esseySection3",
    "projectWrapper9",
    "projectWrapper10"
  ],

  heroSection3: ["heroSection3"],
  esseySection3: ["esseySection3"],
  projectWrapper9: ["projectWrapper9"],
  projectWrapper10: ["projectWrapper10"],
  columnsMobile2: [
    "columnsMobile2",
    "column1Wrapper5",
    "heroSection6",
    "logoMarkWrapp",
    "esseySection4",
    "copyContainer3",
    "projectWrapper11",
    "projectWrapper13",
    "projectWrapper12",
    "esseySection5",
    "copyContainer4"
  ],

  column1Wrapper5: [
    "column1Wrapper5",
    "heroSection6",
    "logoMarkWrapp",
    "esseySection4",
    "copyContainer3",
    "projectWrapper11",
    "projectWrapper13",
    "projectWrapper12",
    "esseySection5",
    "copyContainer4"
  ],

  heroSection6: ["heroSection6", "logoMarkWrapp"],
  logoMarkWrapp: ["logoMarkWrapp"],
  esseySection4: ["esseySection4", "copyContainer3"],
  copyContainer3: ["copyContainer3"],
  projectWrapper11: ["projectWrapper11"],
  projectWrapper13: ["projectWrapper13"],
  projectWrapper12: ["projectWrapper12"],
  esseySection5: ["esseySection5", "copyContainer4"],
  copyContainer4: ["copyContainer4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    section: makeNodeComponent("section"),
    container: makeNodeComponent("container"),
    nav: makeNodeComponent("nav"),
    columnsForNav: makeNodeComponent("columnsForNav"),
    column1Wrapper2: makeNodeComponent("column1Wrapper2"),
    column2Wrapper2: makeNodeComponent("column2Wrapper2"),
    column2Wrapper3: makeNodeComponent("column2Wrapper3"),
    columns: makeNodeComponent("columns"),
    column1Wrapper: makeNodeComponent("column1Wrapper"),
    heroSection: makeNodeComponent("heroSection"),
    logoMarkWrapper: makeNodeComponent("logoMarkWrapper"),
    logoMarkIocn: makeNodeComponent("logoMarkIocn"),
    esseySection: makeNodeComponent("esseySection"),
    copyContainer: makeNodeComponent("copyContainer"),
    copyContainer2: makeNodeComponent("copyContainer2"),
    column2Wrapper: makeNodeComponent("column2Wrapper"),
    heroSection4: makeNodeComponent("heroSection4"),
    esseySectionCopy3: makeNodeComponent("esseySectionCopy3"),
    projectWrapper15: makeNodeComponent("projectWrapper15"),
    projectWrapper18: makeNodeComponent("projectWrapper18"),
    column3Wrapper: makeNodeComponent("column3Wrapper"),
    heroSection5: makeNodeComponent("heroSection5"),
    esseySectionCopy2: makeNodeComponent("esseySectionCopy2"),
    projectWrapper5: makeNodeComponent("projectWrapper5"),
    projectWrapper7: makeNodeComponent("projectWrapper7"),
    columnsMobile: makeNodeComponent("columnsMobile"),
    column1Wrapper4: makeNodeComponent("column1Wrapper4"),
    heroSection3: makeNodeComponent("heroSection3"),
    esseySection3: makeNodeComponent("esseySection3"),
    projectWrapper9: makeNodeComponent("projectWrapper9"),
    projectWrapper10: makeNodeComponent("projectWrapper10"),
    columnsMobile2: makeNodeComponent("columnsMobile2"),
    column1Wrapper5: makeNodeComponent("column1Wrapper5"),
    heroSection6: makeNodeComponent("heroSection6"),
    logoMarkWrapp: makeNodeComponent("logoMarkWrapp"),
    esseySection4: makeNodeComponent("esseySection4"),
    copyContainer3: makeNodeComponent("copyContainer3"),
    projectWrapper11: makeNodeComponent("projectWrapper11"),
    projectWrapper13: makeNodeComponent("projectWrapper13"),
    projectWrapper12: makeNodeComponent("projectWrapper12"),
    esseySection5: makeNodeComponent("esseySection5"),
    copyContainer4: makeNodeComponent("copyContainer4"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
